import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { UserProvider } from "./context/UserContext";
import { ScoreProvider } from "./context/ScoreContext";
import { CommitmentProvider } from "./context/CommitmentContext";
import { NotificationsProvider } from "./context/NotificationsContext";
import "./index.css";
import App from "./App.tsx";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <UserProvider>
      <CommitmentProvider>
        <NotificationsProvider>
          <ScoreProvider>
            <App />
          </ScoreProvider>
        </NotificationsProvider>
      </CommitmentProvider>
    </UserProvider>
  </StrictMode>,
);
